import { Component, computed, inject, OnInit } from '@angular/core';
import { SettingsModel } from '../../models/settings.module';
import { SettingsService } from '../../services/settings.service';
import { appSettings } from '../../app.settings';
import { CookieConsentService } from '../../services/cookie-consent.service';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  settingsModel = appSettings();
  currentYear: number = new Date().getFullYear();

  cookieSettingsShow = computed(() => this.cookieConsentService.showConsent());

  cookieConsentService = inject(CookieConsentService);

  openCookieSettings() {
    this.cookieConsentService.showConsent.set(true);
  }
}
